// @ts-nocheck

import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import dash_api from '../../main/support/dash_api';
import { LOADING_STATUS } from '../support/constants';
import { ReduxAsyncAction } from '../support/utils';
import type { AudienceSegmentEdit, AudienceSegmentUpdatePayload } from '../types/audienceTypes';
import NotificationActions from './NotificationActions';
const AUDIENCE_SEGMENT_PATH = '/v1/audience-segments';
const AUDIENCE_AD_PARTNERS_PATH = '/v1/audience-ad-partners';
const errorProvider = new ErrorProvider();
const GetAudienceSegmentsAndLatestAudiences = new ReduxAsyncAction('GET_AUDIENCE_SEGMENTS_AND_LATEST_AUDIENCES');
GetAudienceSegmentsAndLatestAudiences.registerRequest(function () {
  return dash_api.get(AUDIENCE_SEGMENT_PATH).then(({ data }) => data);
});
export const GET_AUDIENCE_SEGMENTS_AND_LATEST_AUDIENCES = GetAudienceSegmentsAndLatestAudiences.constants;
export const getAudienceSegmentsAndLatestAudiences = GetAudienceSegmentsAndLatestAudiences.request;
const GetActiveAudienceSegmentsCount = new ReduxAsyncAction('GET_ACTIVE_AUDIENCE_SEGMENTS_COUNT');
GetActiveAudienceSegmentsCount.registerRequest(function () {
  return dash_api.get(AUDIENCE_SEGMENT_PATH + '/active-count').then(({ data }) => data);
});
export const GET_ACTIVE_AUDIENCE_SEGMENTS_COUNT = GetActiveAudienceSegmentsCount.constants;
export const getActiveAudienceSegmentsCount = GetActiveAudienceSegmentsCount.request;
export const SET_AUDIENCE_SAVE_REQUEST_STATUS = 'SET_SAVE_AUDIENCE_REQUEST_STATUS';
export function setAudienceSaveRequestStatus(status: number) {
  return {
    type: SET_AUDIENCE_SAVE_REQUEST_STATUS,
    data: status,
  };
}
const CreateAudienceSegment = new ReduxAsyncAction('CREATE_AUDIENCE_SEGMENT');
CreateAudienceSegment.registerRequest(function (audienceSegment: AudienceSegmentEdit) {
  return dash_api
    .post(AUDIENCE_SEGMENT_PATH, {
      audienceSegment,
    })
    .then(({ data }) => data);
});
export const CREATE_AUDIENCE_SEGMENT = CreateAudienceSegment.constants;
export const createAudienceSegment =
  (audienceSegment: AudienceSegmentEdit) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(CreateAudienceSegment.request(audienceSegment));
      dispatch(setAudienceSaveRequestStatus(LOADING_STATUS.LOADED));
      dispatch(getActiveAudienceSegmentsCount());
    } catch (err) {
      dispatch(setAudienceSaveRequestStatus(LOADING_STATUS.ERROR));
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
export const UPDATE_AUDIENCE_SEGMENT_IN_STORE = 'UPDATE_AUDIENCE_SEGMENT_IN_STORE';
export const updateAudienceSegmentInStore = function (audienceSegmentUpdatePayload: AudienceSegmentUpdatePayload) {
  return {
    type: UPDATE_AUDIENCE_SEGMENT_IN_STORE,
    data: audienceSegmentUpdatePayload,
  };
};
const UpdateAudienceSegment = new ReduxAsyncAction('UPDATE_AUDIENCE_SEGMENT');
UpdateAudienceSegment.registerRequest(function (audienceSegmentUpdatePayload: AudienceSegmentUpdatePayload) {
  return dash_api.put(`${AUDIENCE_SEGMENT_PATH}/${audienceSegmentUpdatePayload.id}`, {
    audienceSegmentUpdatePayload,
  });
});
export const UPDATE_AUDIENCE_SEGMENT = UpdateAudienceSegment.constants;
export const updateAudienceSegment =
  (audienceSegmentUpdatePayload: AudienceSegmentUpdatePayload) =>
  async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(UpdateAudienceSegment.request(audienceSegmentUpdatePayload));
      dispatch(setAudienceSaveRequestStatus(LOADING_STATUS.LOADED));
      dispatch(getActiveAudienceSegmentsCount());
      dispatch(updateAudienceSegmentInStore(audienceSegmentUpdatePayload));
    } catch (err) {
      dispatch(setAudienceSaveRequestStatus(LOADING_STATUS.ERROR));
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
export const DELETE_AUDIENCE_SEGMENT_FROM_STORE = 'DELETE_AUDIENCE_SEGMENT_FROM_STORE';
export const deleteAudienceSegmentFromStore = function (audienceSegmentId: string) {
  return {
    type: DELETE_AUDIENCE_SEGMENT_FROM_STORE,
    data: audienceSegmentId,
  };
};
const DeleteAudienceSegment = new ReduxAsyncAction('DELETE_AUDIENCE_SEGMENT');
DeleteAudienceSegment.registerRequest(function (audienceSegmentId: string) {
  return dash_api.delete(`${AUDIENCE_SEGMENT_PATH}/${audienceSegmentId}`);
});
export const DELETE_AUDIENCE_SEGMENT = DeleteAudienceSegment.constants;
export const deleteAudienceSegment =
  (audienceSegmentId: string) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(DeleteAudienceSegment.request(audienceSegmentId));
      dispatch(getActiveAudienceSegmentsCount());
      dispatch(deleteAudienceSegmentFromStore(audienceSegmentId));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
const GetIntegratableAdPartnersList = new ReduxAsyncAction('GET_INTEGRATABLE_AD_PARTNERS_LIST');
GetIntegratableAdPartnersList.registerRequest(function () {
  return dash_api.get(`${AUDIENCE_AD_PARTNERS_PATH}`).then(({ data }) => data);
});
export const GET_INTEGRATABLE_AD_PARTNERS_LIST = GetIntegratableAdPartnersList.constants;
export const getIntegratableAdPartnersList = GetIntegratableAdPartnersList.request;
export const DUPLICATE_AUDIENCE_SEGMENT_BY_ID = 'DUPLICATE_AUDIENCE_SEGMENT_BY_ID';
export const duplicateAudienceSegmentById = function (audienceSegmentId: string) {
  return {
    type: DUPLICATE_AUDIENCE_SEGMENT_BY_ID,
    data: audienceSegmentId,
  };
};
export const UPDATE_NEW_AUDIENCE_SEGMENT_SCRATCHPAD = 'UPDATE_NEW_AUDIENCE_SEGMENT_SCRATCHPAD';
export const updateNewAudienceSegmentScratchpad = function (newAudienceSegment: AudienceSegmentEdit) {
  return {
    type: UPDATE_NEW_AUDIENCE_SEGMENT_SCRATCHPAD,
    data: newAudienceSegment,
  };
};
export const CLEAR_NEW_AUDIENCE_SEGMENT_SCRATCHPAD = 'CLEAR_NEW_AUDIENCE_SEGMENT_SCRATCHPAD';
export const clearNewAudienceSegmentScratchpad = function () {
  return {
    type: CLEAR_NEW_AUDIENCE_SEGMENT_SCRATCHPAD,
  };
};
export const UPDATE_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD = 'UPDATE_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD';
export const updateEditingAudienceSegmentScratchpad = function (editingAudienceSegment: AudienceSegmentEdit) {
  return {
    type: UPDATE_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD,
    data: editingAudienceSegment,
  };
};
export const CLEAR_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD = 'CLEAR_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD';
export const clearEditingAudienceSegmentScratchpad = function () {
  return {
    type: CLEAR_EDITING_AUDIENCE_SEGMENT_SCRATCHPAD,
  };
};
